import LandingScreen from "./landingScreen";
import RepublicQuiz from './quiz';

const republicDayCamp = {
    LandingScreen,
    RepublicQuiz
}

export default republicDayCamp;